import { WizardWithSummaryFormWrapper } from "../layout/forms/wizard/WizardWithSummaryFormWrapper";
import { useWizardFormKit } from "./useWizardFormKit";

export const WizardWithSummaryFormKit = ({ steps, initialStep, initialValues, onSubmit, onBack, SummaryComponent, summaryProps }) => {
    const {
        control,
        handleSubmit,
        buttonLabel,
        Stepper,
        step,
        goBack
    } = useWizardFormKit({ steps, initialStep, initialValues, onSubmit, onBack });

    return (
        <>
            <Stepper/>

            <WizardWithSummaryFormWrapper
                control={control}
                handleSubmit={handleSubmit}
                goBack={goBack}
                buttonLabel={buttonLabel}
                formFields={step}
                summary={<SummaryComponent control={control} {...summaryProps}/>}
            />
        </>
    );
};
